import { useState, useEffect } from 'react';
import cx from 'classnames';

type DividerProps = {
  className?: string;
}

const Divider = (props: DividerProps) => {
  const {
    className = 'my-4',
  } = props;

  return (
    <hr className={cx('border-t border-white/[0.1]', className)}/>
  );
}

export default Divider;
